import CasinoImageBox from "components/casinoImageBox";
import { useSelector } from "react-redux";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import Appconfig from '../../config/config'
import CasinoLayout from "components/casinoLayout";
import { useEffect, useState } from "react";

function Evolution() {
    const casinoImages = [
        {
            src: '/assets/images/casino/withoutLogin/3-Cards-Judgement.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/7-UP-and-Down.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Amar-Akbar-Anthony.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Auto-Roulette.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Bollywood-Casino.webp'

        },
        {
            src: '/assets/images/casino/withoutLogin/Book-Cricket.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Casino-War.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Cricket-War.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Dragon-Tiger.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/High-Low.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Lottery.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Muflis-Teen-Patti.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Teen-Patti.webp'
        },
        {
            src: '/assets/images/casino/withoutLogin/Worli-Matka.webp'
        }
    ]
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [iframeUrl, setIframeUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                console.log('status:', status)
                if (status === "SUCCESS") {
                    setIframeUrl(response.data.launchURL);
                    setLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                    setLoading(false);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                    setLoading(false);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }

    useEffect(() => {
        if (profileData) {
            CreateAndLaunchWCOCasino('EVZ', '', 'EV')
        }
    }, [profileData])
    return (
        <>
            <CasinoLayout casinoImages={[]} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} iframeUrl={iframeUrl} setIframeUrl={setIframeUrl} />
        </>
    );
}

export default Evolution;